import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { Grid as GridComponent } from '@elfsight/lib-masonry-grid';
import { useSettings } from '@wu/widget-core';
import type { Job } from '../../../types';
import { Item } from '../items';
import { LayoutContainer } from '../LayoutContainer';

type GridProps = HTMLAttributes<HTMLDivElement> & {
  jobs: Job[];
};

export const Grid = forwardRef<HTMLDivElement, GridProps>(
  ({ jobs, ...forwardingProps }, ref) => {
    const { gridLayoutColumns: columns, gridLayoutGap: gap } = useSettings();

    return (
      <LayoutContainer gap={gap} ref={ref} {...forwardingProps}>
        <GridComponent
          className="Grid__Container-sc"
          onEffectiveColumnsChange={() => {}}
          columns={columns}
          basis={280}
          gap={gap}
        >
          {jobs.map((item) => (
            <Item data={item} key={item.id} />
          ))}
        </GridComponent>
      </LayoutContainer>
    );
  }
);
